import React, { Fragment, Component }   from 'react';
import PropTypes                        from 'prop-types';
import { Button, Popup }                from 'semantic-ui-react';
import FormModal                        from './FormModal';

import { modalTitleByTypeForUpdate }    from 'constants/Calculations';

// -----------------------------------------------------
// Settings
// -----------------------------------------------------

const title = 'Edit calculation.';

// -----------------------------------------------------
// Component Definition
// -----------------------------------------------------

class EditButton extends Component {
  state = { opened: false }

  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  render() {
    const { opened }            = this.state;
    const { calculation }       = this.props;
    const { calculation_type }  = calculation;
    const modalTitle            = modalTitleByTypeForUpdate[calculation_type];

    const Btn = <Button icon='pencil'
                        basic
                        color='blue'
                        onClick={ this.handleClick } />;

    return (
      <Fragment>
        <FormModal  title={ modalTitle }
                    opened={ opened }
                    calculationType={ calculation_type }
                    onClose={ this.handleClose }
                    { ...this.props } />

        <Popup  trigger={ Btn }
                content={ title }
                position='top center' />
      </Fragment>
    );
  }

  handleClick() {
    this.setState({ opened: true });
  }

  handleClose() {
    this.setState({ opened: false });
  }
}

// -----------------------------------------------------
// PropTypes
// -----------------------------------------------------

EditButton.propTypes = {
  calculation:  PropTypes.object.isRequired,
  onSubmit:     PropTypes.func.isRequired
};

// -----------------------------------------------------
// Exports
// -----------------------------------------------------

export default EditButton;
